import { isItemInList } from '../../../utility/helpers';

export const SCROLLBAR_HEIGHT = 200;
const SELECT_ALL_HEIGHT = 40;

export const isDirty = (preselectedUsers = [], selectedUsers = []) =>
  preselectedUsers.length !== selectedUsers.length ||
  selectedUsers.some(user => !isItemInList(preselectedUsers, user));

export const setPopperWidth = (reference, popper, dropdownWidth) => {
  popper.style.width = dropdownWidth || `${reference.offsetWidth + 24}px`;
};

export const getScrollbarHeight = (
  hasSelectAll,
  hasAssociates,
  hasEmployees
) => {
  if (hasSelectAll) {
    let heightToSubtract = 0;

    if (hasAssociates || hasEmployees) {
      heightToSubtract = SELECT_ALL_HEIGHT;
    }

    if (hasAssociates && hasEmployees) {
      heightToSubtract = SELECT_ALL_HEIGHT * 2;
    }

    return SCROLLBAR_HEIGHT - heightToSubtract;
  }

  return SCROLLBAR_HEIGHT;
};
